import { setUserItemSelected } from 'features/menu/menu.slice';
import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { logout } from 'features/auth/auth.slice';
import { useApiToast } from 'components/Toaster';
import { useGetUserProfileMutation } from 'services/user/user.endpoint';
import { User } from 'services/auth/auth.types';

export default function useUserHeaderVM() {
    const [me, setMe] = useState<User>({} as User);

    const dispatch = useDispatch();

    const { showApiToast, showErrorToast } = useApiToast();
    const [getMe, { isLoading: isMeLoading, isError: isMeError, isSuccess: isMeSuccess, error: meError, data: meResponse }] =
        useGetUserProfileMutation();

    useEffect(() => {
        getMe(undefined);
    }, [getMe]);

    useEffect(() => {
        if (isMeLoading) return;
        if (isMeError && meError) {
            showErrorToast(meError, {
                message: 'Erreur lors de la récupération du profil'
            });
            return;
        }
        if (isMeSuccess && meResponse) {
            setMe(meResponse.data);
        }
    }, [isMeLoading, isMeError, isMeSuccess, meError, meResponse, showErrorToast]);

    const handleMenuClick = (label: string, index: number) => {
        label === 'Déconnexion' && dispatch(logout());
        dispatch(setUserItemSelected({ itemSelected: index }));
    };

    return {
        handleMenuClick
    };
}
